import SubscribeForm from "./SubscribeForm";
import { brandName } from "@/mocks/guaContent";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20hero%20illustration%20of%20a%20playful%20watermelon%20field%20with%20popcorn%20and%20floating%20hot%20news%20speech%20bubbles%2C%20fresh%20leaf%20green%20and%20coral%20crimson%20palette%20on%20warm%20cream%20ground%2C%20flat%20stylized%20vector%20art%2C%20soft%20linen%20paper%20texture%2C%20minimal%20clean%20premium%20composition&width=1920&height=1080&seq=gua-hero-01&orientation=landscape"
          alt="今日瓜报：瓜田日报与瓜田周报每日更新、定期推送"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative w-full max-w-5xl mx-auto px-4 md:px-6 pt-40 pb-24 md:pt-52 md:pb-32 text-center text-white">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur border border-white/25 px-4 py-1.5 text-xs tracking-wide">
          <i className="ri-fire-line text-primary-400"></i>
          每日更新 · 定期推送 · 瓜田新鲜直达邮箱
        </span>

        <h1 className="mt-6 font-heading text-4xl md:text-6xl font-black leading-tight">
          把今天的瓜，<span className="text-primary-400">都给你攒齐</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-base md:text-lg text-white/85 leading-relaxed">
          {brandName}是一款面向爱吃瓜用户的泛娱乐资讯订阅：内娱、影视综艺、乐坛、海外、体坛、时尚六大频道一站覆盖。
          订阅<span className="text-white font-medium">瓜田日报</span>每日更新，或选<span className="text-white font-medium">瓜田周报</span>邮件订阅定期送达，
          热门爆料与深度内容都不错过，轻松养成熟瓜田。
        </p>

        <div className="mx-auto mt-9 max-w-xl">
          <SubscribeForm id="subscribe-hero" variant="row" placeholder="输入邮箱，开启你的第一份瓜报" />
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/75">
          <span className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-300"></i> 无广告打扰
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-close-circle-line text-accent-300"></i> 随时一键退订
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-mail-send-line text-accent-300"></i> 已送出 3200+ 期
          </span>
        </div>
      </div>
    </section>
  );
}